import jQuery from 'jquery';
import VcomProvider from '../VcomProvider';
import EventService from '../common/event/EventService';
import SystemIdDetector from '../vcom/administration/systemIdDetector';
import AdministrationMenuService from './AdministrationMenuService';

function openAdministrationWhenAdministrationPath() {
  if (!window.location.hash.includes('administration')) {
    return;
  }

  if (window.location.hash.length > 2) {
    VcomProvider.adminSystemId = AdministrationMenuService.extractSystemId(window.location.hash);
    EventService.dispatch('openAdministrationMenu', { target: document });
  }
}

function installListenerForAdministrationRoutes() {
  window.addEventListener('hashchange', () => {
    if (!window.location.hash.includes('administration')) {
      return;
    }
    if (window.location.hash.length > 2) {
      VcomProvider.adminSystemId = AdministrationMenuService.extractSystemId(window.location.hash);
    }
    if (document.querySelector('administration-menu') !== null) {
      return;
    }
    EventService.dispatch('openAdministrationMenu', { target: document });
  }, false);
}

function openAdministrationWhenSystemHasNoLicense(settings) {
  if (settings.showSystemLicenseHint) {
    VcomProvider.adminSystemId = settings.systemId;

    if (!settings.isSuperAdmin) {
      EventService.dispatch('openAdministrationMenuBase', { target: document });
    }
  }
}

export default function administrationSetup(settings) {
  const systemIdDetector = new SystemIdDetector(VcomProvider, jQuery);

  jQuery('body').on('click', '.administration-control', (event) => {
    VcomProvider.adminSystemId = systemIdDetector.getSystemId(event);

    const { page } = event.currentTarget.dataset;
    if (page) {
      window.location.hash = page;
      return;
    }

    EventService.dispatch('openAdministrationMenuBase', { target: document });
  });

  jQuery('body').on('click', '.administration-control-monitoring', (event) => {
    VcomProvider.adminSystemId = systemIdDetector.getSystemId(event);

    const { page, deepPage } = event.currentTarget.dataset;
    window.location.hash = `#/administration/${VcomProvider.adminSystemId}/${page}/${deepPage}`;
  });

  jQuery('body').on('click', '#open-simulation-configuration', (event) => {
    VcomProvider.adminSystemId = systemIdDetector.getSystemId(event);
    window.location.hash = `#/administration/${VcomProvider.adminSystemId}/${event.currentTarget.dataset.page}`;
  });

  jQuery('body').on('click', '#configure-yield-forecast', (event) => {
    VcomProvider.adminSystemId = systemIdDetector.getSystemId(event);
    window.location.hash = `#/administration/${VcomProvider.adminSystemId}/${event.currentTarget.dataset.page}`;
  });

  jQuery('body').on('click', '#open-datalogger-overview', (event) => {
    event.preventDefault();
    VcomProvider.adminSystemId = systemIdDetector.getSystemId(event);
    window.location.hash = `#/administration/${VcomProvider.adminSystemId}/dataSource/dataloggerOverview`;
  });

  jQuery('body').on('click', '#open-target-pr', (event) => {
    event.preventDefault();
    VcomProvider.adminSystemId = systemIdDetector.getSystemId(event);
    window.location.hash = `#/administration/${VcomProvider.adminSystemId}/calculated/targetPr`;
  });

  openAdministrationWhenAdministrationPath();
  installListenerForAdministrationRoutes();
  openAdministrationWhenSystemHasNoLicense(settings);
}
